import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { SearchIcon, GripHorizontal, QrCode, Newspaper, Calendar } from "lucide-react"
import homeimage from "../../assets/homeimage.jpg"
import cityimage from "../../assets/City.png"
import cityimage2 from "../../assets/CityDefault.png"
import landimage from "../../assets/IlzerLand.JPG"
import enhancedImage from "../../assets/image_with_white_background_around_boxes.jpg"
const newsList = [
    {
        title: "Kino am Rathaus",
        description: "Das Kino am Rathaus in Gutersloh uberzeugt mit seinem charmanten Ambiente",
        imageUrl: homeimage
    },
    {
        title: "Stadtpark Konzerte",
        description: "Genießen Sie Live-Musik im malerischen Stadtpark von Gutersloh.",
        imageUrl: cityimage
    },
    {
        title: "Historisches Museum",
        description: "Entdecken Sie die Geschichte der Region im Historischen Museum.",
        imageUrl: cityimage2
    },
    {
        title: "Kulinarische Wochen",
        description: "Probieren Sie lokale Spezialitäten während der kulinarischen Wochen.",
        imageUrl: landimage
    },
    {
        title: "Kino am Rathaus",
        description: "Das Kino am Rathaus in Gutersloh uberzeugt mit seinem charmanten Ambiente",
        imageUrl: homeimage
    },
    {
        title: "Stadtpark Konzerte",
        description: "Genießen Sie Live-Musik im malerischen Stadtpark von Gutersloh.",
        imageUrl: cityimage
    },
    {
        title: "Historisches Museum",
        description: "Entdecken Sie die Geschichte der Region im Historischen Museum.",
        imageUrl: cityimage2
    },
    {
        title: "Kulinarische Wochen",
        description: "Probieren Sie lokale Spezialitäten während der kulinarischen Wochen.",
        imageUrl: landimage
    },
]
const tablist = [
    { title: "Alle Kategorien", icon: <QrCode size={16} /> },
    { title: "Neuigkeiten", icon: <Newspaper size={16} /> },
    { title: "Veranstaltungen", icon: <QrCode size={16} /> },
    { title: "ClubNews", icon: <Calendar size={16} /> },
    { title: "Gastronomy", icon: <QrCode size={16} /> },
]
function GetContent(title, orientation) {
    return (
        <div>
            <div className="flex justify-between pl-3 pr-3 text-black font-semibold text-white">
                <h1 className="pl-1 text-black">{title}{':'}</h1>
                <GripHorizontal className="text-black" />
            </div>
            <div className={`${orientation=="horizontal"?'':'grid md:grid-cols-8 sm:grid-cols-9 grid-cols-8  gap-2 p-2 '}`}>
                {
                    newsList.map((item, index) => (
                        <div key={index} className="border rounded-lg shadow-lg col-span-2 md:col-span-2 sm:col-span-3 col-span-4">
                            <img
                                src={item.imageUrl}
                                alt={item.title}
                                className="rounded-t-lg object-cover"
                                style={{ height: "100px", width: "100%" }}
                            />
                            <div className="p-2">
                                <h1 className="text-sm">{item.title}</h1>
                                <p className="text-xs truncate">{item.description}</p>
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

function TempletPreview1({ isopen, setIsOpen, orientation }) {
    const { t } = useTranslation()
    return (
        <>
            {(isopen === "A") && <div className="fixed inset-0 pt-10 z-50 flex items-center justify-center backdrop-blur-sm bg-black/40">
                <div className="bg-white rounded-lg shadow-xl max-w-[520px] w-full relative overflow-y-auto h-[460px]">
                    <button
                        onClick={() => setIsOpen(null)}
                        className="fixed top-2 right-2 z-20 text-white hover:text-red-500 text-4xl"
                    >
                        &times;
                    </button>
                    <div className="w-full mr-0 ml-0">
                        <div className="h-[30rem] h-full overflow-hidden px-0 py-0 relative">
                            <div className="relative h-[10rem]">
                                <img
                                    alt="ecommerce"
                                    className="object-cover object-center h-full w-full"
                                    src={process.env.REACT_APP_BUCKET_HOST + "admin/Homepage.jpg"}
                                    loading="lazy"
                                />
                                <div className="absolute inset-0 flex flex-col gap-4 items-start justify-center bg-gray-800 bg-opacity-75 text-white z--1">
                                    <div className="flex justify-between mt-10 w-full lg:px-10 md:px-5 px-5 py-6">
                                        <h1
                                            className="font-sans mb-8 lg:mb-12 text-sm font-bold tracking-wide"
                                            style={{
                                                fontFamily: "Poppins, sans-serif",
                                            }}
                                        >
                                            {t("homePageHeading")}
                                        </h1>
                                        <div className="w-full ml-4  pl-2 pr-2 h-9 rounded-md flex justify-end bg-gray-200/20 text-xs">
                                            <div className="p-2 pt-2.5">
                                                <SearchIcon size={14} />
                                            </div>
                                            <input
                                                type="text"
                                                placeholder="Wo suchen Sie?"
                                                className="bg-transparent w-full outline-none"
                                            />
                                            <div className="pt-1.5">
                                                <button className="rounded-md bg-gray-200/40 p-1">Finden</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex w-full justify items-center h-16 overflow-x-auto absolute top-24">
                            {
                                tablist.map((item, index) => (
                                    <div
                                        key={index}
                                        className={`flex min-w-40 items-center gap-2 px-4 mx-4 py-2 text-xs mt-4 font-semibold ${(index === 0) ? 'text-black bg-white rounded-t-md' : 'text-white'}`}
                                    >
                                        {item.icon}
                                        {item.title}
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                    <div className={`${orientation==="horizontal"?'grid grid-cols-2':''}`}>
                        <div className="p-2">
                            {
                                GetContent("All Kategorien", orientation)
                            }
                        </div>
                            <div className={`${orientation=="horizontal"?'':'flex flex-col justify-center items-center'}  pl-4 pr-4 font-bold p-2`}>
                            <p>Weitere Services</p>
                            <img src={enhancedImage} alt="preimage1" width={600} />
                        </div>
                    </div>
                </div>
            </div>}
        </>
    )
}

export default TempletPreview1;